import React from 'react'
import { Box } from '@hub/box'
import { Button } from '@hub/button'
import { LinkBox, LinkOverlay } from '@hub/link'

export interface IFooterLinkProps {
  label: string
  link: string
}

interface IFooterLinksProps {
  links: IFooterLinkProps[]
}

const FooterLinks: React.FC<React.PropsWithChildren<IFooterLinksProps>> = ({
  links,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 'var(--chakra-space-size-2)',
      }}
    >
      {links.map(({ label, link }, i) => (
        <LinkBox key={i}>
          <LinkOverlay href={link}>
            <Button variant="lowerLink" colorScheme="smokeQuartz" size="sm">
              {label}
            </Button>
          </LinkOverlay>
        </LinkBox>
      ))}
    </Box>
  )
}

export default FooterLinks
